import { AtActive as AT } from '/Assets/Js/Types%5EIndex.compiled.js?v=a1b25ba8f32e66d551653b5c64742f18d78a5fa6a1cff8666f1f3ec1f6d038ee';
let Constants = AT.Web.Constants;  
let Html = AT.Web.Html;

export namespace Main {
    export async function Init(): Promise<void> {
        await Constants.Config.Load();
        Constants.Global.Debug(Constants.LogLevel.log, "✅ WebVariables loaded:", Constants.Config.entries());
        Html.Form.SetInputIdsFromNames();
    }
}
(async () => { await Main.Init(); })().catch(err => { }); 